var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "columns is-mobile is-gapless is-fullheight" },
    [
      _c("transition", { attrs: { name: "sidebar" } }, [
        _c(
          "aside",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$store.state.visibleSidebar,
                expression: "$store.state.visibleSidebar",
              },
            ],
            staticClass: "column is-narrow aside hero sidebar",
          },
          [_c("sidebar")],
          1
        ),
      ]),
      _c("transition", { attrs: { name: "sidebar-replace" } }, [
        _c("aside", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$store.state.visibleSidebar,
              expression: "$store.state.visibleSidebar",
            },
          ],
        }),
      ]),
      _c(
        "div",
        {
          staticClass: "column overflow-hidden",
          attrs: { id: "site-wrapper" },
        },
        [
          _c(
            "main",
            { staticClass: "site-content" },
            [_c("navbar"), _c("router-view")],
            1
          ),
          _c("dash-footer"),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ai-fab", class: { "is-hidden": _vm.aiChatOpen } },
        [
          _c(
            "button",
            {
              staticClass: "ai-bubble",
              class: { "is-off": _vm.aiFabFolded },
              attrs: { type: "button", "aria-label": "Open AI assistance" },
              on: {
                click: function ($event) {
                  _vm.aiChatOpen = true
                },
              },
            },
            [
              _c(
                "span",
                { staticClass: "ai-bubble-inner" },
                [_c("b-icon", { attrs: { icon: "robot", size: "is-medium" } })],
                1
              ),
              _c("span", {
                staticClass: "ai-bubble-ping",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "ai-fold-handle",
              class: { "is-off": _vm.aiFabFolded },
              attrs: { type: "button", "aria-label": "Fold AI assistant" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.aiFabFolded = true
                },
              },
            },
            [_vm._v(" › ")]
          ),
          _c(
            "button",
            {
              staticClass: "ai-fold-tab",
              class: { "is-on": _vm.aiFabFolded },
              attrs: { type: "button", "aria-label": "Unfold AI assistant" },
              on: {
                click: function ($event) {
                  _vm.aiFabFolded = false
                },
              },
            },
            [_vm._v(" ‹ ")]
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.aiChatOpen,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.aiChatOpen = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-card",
              staticStyle: { width: "640px", "max-height": "80vh" },
            },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v(" AI assistance "),
                ]),
                _c("button", {
                  staticClass: "delete",
                  attrs: { "aria-label": "close" },
                  on: {
                    click: function ($event) {
                      _vm.aiChatOpen = false
                    },
                  },
                }),
              ]),
              _c(
                "section",
                {
                  staticClass: "modal-card-body",
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    gap: "1rem",
                    "max-height": "60vh",
                  },
                },
                [
                  !_vm.aiMessages.length
                    ? _c("div", { staticClass: "has-text-grey" }, [
                        _vm._v(
                          " Ask the assistant to check the status on a shipping. "
                        ),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "ai-chat-messages",
                          staticStyle: { flex: "1", "overflow-y": "auto" },
                        },
                        _vm._l(_vm.aiMessages, function (m, idx) {
                          return _c(
                            "article",
                            {
                              key: idx,
                              staticClass: "message",
                              class:
                                m.from === "user" ? "is-info" : "is-success",
                            },
                            [
                              _c("div", { staticClass: "message-body" }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      m.from === "user" ? "You" : "Assistant"
                                    )
                                  ),
                                ]),
                                _c("br"),
                                _c(
                                  "span",
                                  {
                                    staticStyle: { "white-space": "pre-wrap" },
                                  },
                                  [_vm._v(_vm._s(m.text))]
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                ]
              ),
              _c(
                "footer",
                {
                  staticClass: "modal-card-foot",
                  staticStyle: { "align-items": "flex-end" },
                },
                [
                  _c(
                    "b-field",
                    { staticStyle: { flex: "1", "margin-right": "0.75rem" } },
                    [
                      _c("b-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "Type your question and press Enter...",
                          disabled: _vm.aiLoading,
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            if (
                              $event.ctrlKey ||
                              $event.shiftKey ||
                              $event.altKey ||
                              $event.metaKey
                            )
                              return null
                            $event.preventDefault()
                            return _vm.sendAiMessage.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.aiInput,
                          callback: function ($$v) {
                            _vm.aiInput = $$v
                          },
                          expression: "aiInput",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        type: "is-primary",
                        loading: _vm.aiLoading,
                        disabled:
                          !_vm.aiInput || !_vm.aiInput.trim() || _vm.aiLoading,
                      },
                      on: { click: _vm.sendAiMessage },
                    },
                    [_vm._v(" Send ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }